module.exports = __webpack_public_path__ + "static/media/tnpa-aboutus1.85b6c61b.png";